import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fountain/ripple/styles';
import '@/styles/globals.css';
import '@/styles/tailwind.css';
// Import yup plugin FIRST to ensure custom methods are available before any components load
import './plugins/yup';
import App from './AppWorker.tsx';
import { initDatadogRum, initDatadogLogs } from './plugins/datadog.ts';

import { setBaseUrl } from '@/utils/_shared/apiUtils';

setBaseUrl();
initDatadogRum();
initDatadogLogs();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
